import React, { Component } from 'react';
import {
   Header,
   Segment
 } from 'semantic-ui-react'
 import { API } from 'aws-amplify';
import CreateItemModal from './createItem'
import EditItemModal from './editItem'

import _ from 'lodash';
let apiName = 'SyncronicityCRUD';
let path = '/Syncronicity';

class Syncronicity extends Component {
constructor(props){
    super(props)
    this.state = {itemData: {}, item: {}}
  }

getItems = () => {
    API.get(apiName, path).then(response => {
      this.setState({
       itemData: response.data
      });
    });
  }

  getItem = (id) => {
  let single_path = '/Syncronicity/' + id
  console.log(single_path)
  API.get(apiName, single_path).then(response => {
    console.log(response)
    this.setState({
      item: response
    })
  });
}

componentDidMount(){
    this.getItems()
  }

render() {
    const itemData = this.state.itemData;
    return (
      <Segment.Group>
        <Segment>
          <Header
            as='h2'
            icon='eye'
            content='Observations and Reports From Other Users' />
          </Segment>
          <Segment>
          </Segment>
          <Segment>
          <CreateItemModal  getItems={this.getItems}/>
        </Segment>
          {_.map(itemData, ({ID, Title, Abstract, URL }) => (
            <Segment key={ID}>
              <Header
                as='h2'
                onClick={() => this.getItem(ID)}
                icon='dropdown'
                content={Title} />
              <a href={URL}>{URL}</a>
              <p>{Abstract}</p>
              <EditItemModal item={Object.values(this.state.item)} getItems={this.getItems} />
            </Segment>
          ))}
      </Segment.Group>
    );
  }
}
export default Syncronicity;



// WEBPACK FOOTER //
// ./src/components/syncronicity.js